import { useMemo } from 'react';

import { LedgerAccount } from '@work4all/models/lib/Classes/LedgerAccount.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const useLedgerAccountRequestData = (id: string | number) => {
  return useMemo<DataRequest>(() => {
    const LedgerAccountRequestData: LedgerAccount<EMode.query> = {
      id: null,
      name: null,
      accountGroup: null,
      bankAccount: null,
      costCenterId: null,
      costCenterNumber: null,
      costGroupId: null,
      delimitationAccount: null,
      delimitationForm: null,
      depositAccount: null,
      disabled: null,
      insertTime: null,
      isAutomationAccount: null,
      isOverheadCost: null,
      kind: null,
      ledgerAccountType: null,
      notDeminishingTurnover: null,
      number: null,
      short: null,
      substituteAccountVatConversion: null,
      withoutTaxKey: null,
      taxKey: {
        accountId: null,
        creditor: null,
        id: null,
        note: null,
        taxKeyValue: null,
        vat: null,
        vatRate: {
          disabled: null,
          id: null,
          sentence: null,
          sequence: null,
        },
      },
      taxKeyValue: null,
      updateTime: null,
    };
    const filter = [{ id: { $eq: id } }];
    const data = LedgerAccountRequestData;
    return {
      entity: Entities.ledgerAccount,
      data,
      filter,
    };
  }, [id]);
};
